import { CheckCircle2, Circle } from 'lucide-react';
import type { FacilitySignal } from '../../../services/api/facilityMetricsService';
import { getSignalCount } from '../utils/readinessUtils';

export default function SetupStep({ signal }: { signal: FacilitySignal }) {
    const pct =
        signal.target != null && signal.target > 0
            ? Math.min(Math.round((signal.current / signal.target) * 100), 100)
            : 0;

    const barColor = signal.met
        ? 'bg-emerald-500'
        : pct > 0
        ? 'bg-amber-500'
        : 'bg-zinc-500';

    const isInProgress = !signal.met && pct > 0;

    return (
        <div className="px-3 py-2.5">
            <div className="flex items-center gap-3">
                {signal.met ? (
                    <CheckCircle2
                        className="h-4 w-4 shrink-0 text-emerald-500"
                        aria-hidden="true"
                    />
                ) : isInProgress ? (
                    <div className="relative h-4 w-4 shrink-0">
                        <Circle
                            className="absolute inset-0 h-4 w-4 text-amber-500/30"
                            aria-hidden="true"
                        />
                        <div
                            className="absolute inset-[3px] rounded-full bg-amber-500"
                            style={{ opacity: 0.6 }}
                        />
                    </div>
                ) : (
                    <Circle
                        className="h-4 w-4 shrink-0 text-muted-foreground/30"
                        aria-hidden="true"
                    />
                )}
                <span
                    className={`flex-1 text-sm ${
                        signal.met ? 'text-foreground' : 'text-muted-foreground'
                    }`}
                >
                    {signal.label}
                </span>
                <span className="text-xs tabular-nums text-muted-foreground">
                    {getSignalCount(signal)}
                </span>
            </div>
            {signal.target != null && signal.target > 0 && (
                <div className="mt-1.5 ml-7 h-1 overflow-hidden rounded-full bg-white/10">
                    <div
                        className={`h-full rounded-full transition-all ${barColor}`}
                        style={{ width: `${pct}%` }}
                    />
                </div>
            )}
        </div>
    );
}
